import { render } from "./UpdateStore.vue?vue&type=template&id=62f4402f"
import script from "./UpdateStore.vue?vue&type=script&lang=js"
export * from "./UpdateStore.vue?vue&type=script&lang=js"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__